import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  details: null,
  editMode: false,
  history: [],
  loading: false,
  error: null,
};

const bookingSlice = createSlice({
  name: 'booking',
  initialState,
  reducers: {
    setBookingDetails(state, action) {
      state.details = action.payload;
    },
    setEditMode(state, action) {
      state.editMode = action.payload;
    },
    clearBooking(state) {
      state.details = null;
      state.editMode = false;
    },
    setBookingHistory(state, action) {
      const payload = action.payload?.data ?? action.payload;
      state.history = Array.isArray(payload) ? payload : payload ? [payload] : [];
      state.loading = false;
      state.error = null;
    },
    setBookingHistoryLoading(state) {
      state.loading = true;
      state.error = null;
    },
    setBookingHistoryError(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    logout: () => initialState,
  },
  // extraReducers: (builder) => {
  //   builder.addCase('getParcelById_SUCCESS', (state, action) => {
  //     if (!Array.isArray(state.history)) {
  //       state.history = [];
  //     }
  //     const rawParcel = Array.isArray(action.payload)
  //       ? action.payload[0]
  //       : action.payload;
  //     const newParcel =
  //       rawParcel && rawParcel.data ? rawParcel.data : rawParcel;
  //     if (!newParcel) return;
  //     const parcelId = newParcel.parcelId;
  //     const idx = state.history.findIndex((p) => p.parcelId === parcelId);
  //     if (idx !== -1) {
  //       state.history[idx] = newParcel;
  //     } else {
  //       state.history.push(newParcel);
  //     }
  //     state.loading = false;
  //     state.error = null;
  //   });
  // },
});

export const {
  setBookingDetails,
  setEditMode,
  clearBooking,
  setBookingHistory,
  setBookingHistoryLoading,
  setBookingHistoryError,
  logout,
} = bookingSlice.actions;

// Thunk for fetching booking details by id (mocked)
export const fetchBookingDetailsById = (id) => async (dispatch) => {
  try {
    dispatch(setBookingHistoryLoading());
    const data = await new Promise((resolve) =>
      setTimeout(() => resolve(getMockBookingById(id)), 300)
    );
    dispatch(setBookingDetails(data));
  } catch (err) {
    dispatch(setBookingHistoryError('Failed to fetch booking details'));
  }
};

export default bookingSlice.reducer;
